import { __assign } from "tslib";
export var helpcenterContactApiRelativePath = "/helpcenter/contact";
export var createHelpcenterContactApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(helpcenterContactApiRelativePath);
    return {
        getContactSettings: function (dto) {
            return http.get("".concat(apiUrl, "/").concat(dto.locale).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        updateContactSettings: function (dto) {
            return http.put("".concat(apiUrl, "/").concat(dto.locale), dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        }
    };
};
//# sourceMappingURL=index.js.map